// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3mkiT","footer":"Form_footer__39EZ0"};